export default {"src":"/_next/static/media/order_calendar.5c1e5c14.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};